import React, { useState } from 'react';
import InfoIcon from './InfoIcon';

const badgeConfig = {
  popular: { text: 'Most Popular!', from: '#6EC9AB', to: '#00A3DA' },
  limited: { text: 'Limited Stock', from: '#C01F85', to: '#009CFF' },
  lowCost: { text: 'Low Cost', from: '#6EC9AB', to: '#00A3DA' },
};

export default function TopCard({
  item,
  quantity,
  price,
  showProductsOneRow,
  currencyStore,
  productTitle,
  badgeType = 'popular',
  limitedProductCount,
  limitedProductMaxCount,
  onAdd,
  onRemove,
  onBlur,
  currAmount,
  onQuantityChange,
}) {
  const { text, from, to } = badgeConfig[badgeType] || badgeConfig.popular;

  const displayedCount = limitedProductCount > limitedProductMaxCount ? 0 : limitedProductMaxCount - limitedProductCount;
  const [showDesc, setShowDesc] = useState(false);
  const isPink = displayedCount > 0;

  return (
    <div className="bg-white border border-[#00A3DA] rounded-lg flex flex-col items-center p-1 md:p-2 mb-2" tabIndex={0} onBlur={onBlur}>
      {/* header */}
      <div className="flex w-full justify-between items-center ml-1">
        <h3 className="font-brandingBold text-[#00A3DA] text-left">{item.name}</h3>
        <span
          className="text-white text-xs font-semibold rounded-full px-3 py-1"
          style={{ backgroundImage: `linear-gradient(to right, ${from}, ${to})` }}
        >
          {text}
        </span>
      </div>

      {/* body */}
      <div className="w-full flex flex-col mt-1">
        <div className="flex items-center w-full justify-center">
          <img
            src={item.image_link}
            alt={item.name}
            className={`${showProductsOneRow ? '' : 'hidden-'} md:block w-16 h-16 object-cover mr-2 rounded shadow-md`}
          />

          <div className="w-full flex flex-col">
            <div className="flex items-center w-full justify-between">
              <p
                className="
      flex-1
      font-branding text-[13px] leading-[12px]
      text-left decoration-[1px] text-[#00A3DA]
      whitespace-normal
    "
              >
                {productTitle}
              </p>

              <button
                onClick={e => {
                  e.stopPropagation();
                  setShowDesc(s => !s);
                }}
                className="p-1"
              >
                <InfoIcon className="w-5 h-5 text-[#00A3DA]" />
              </button>
            </div>

            <div className="text-left">
              {limitedProductMaxCount != null && (
                <>
                  {limitedProductCount === 0 ? (
                    <span className="text-red-500">Out of Stock</span>
                  ) : (
                    <>
                      <span className="text-[#00A3DA]">Only</span>
                      <span className={`whitespace-nowrap ${!isPink ? 'text-[#00A3DA]' : 'text-pink'}`}> {displayedCount} Left</span>
                    </>
                  )}
                </>
              )}
            </div>
            {/* price + qty controls */}
            <div className={`flex items-center justify-between w-full ${limitedProductMaxCount ? '' : 'mt-2 md:mt-4'}`}>
              {/* price */}
              <div className="flex items-center bg-[#E9F7FF] rounded px-2 py-1">
                <span className="font-brandingBold text-[#00A3DA] text-[17px] px-2 py-1 leading-[12px] text-center">
                  {(() => {
                    const displayPrice = quantity > 0 ? price * quantity : price;
                    return currAmount(currencyStore, displayPrice);
                  })()}
                </span>
              </div>

              {/* “–  qty  +” */}
              <div className="flex items-center bg-[#E9F7FF] p-1 rounded min-w-[107px] justify-between">
                <button
                  className={`bg-[#01A7E1] text-white text-2xl font-bold py-1.5 px-1.5 rounded leading-3 ${
                    limitedProductCount === 0 ? 'bg-gray-300 text-gray-500' : ''
                  }`}
                  onClick={onRemove}
                  disabled={quantity === 0 || limitedProductCount === 0}
                >
                  –
                </button>
                <input
                  type="number"
                  min={0}
                  value={quantity}
                  onClick={e => e.stopPropagation()}
                  onChange={e => {
                    const val = parseInt(e.target.value, 10) || 0;
                    onQuantityChange(item, Math.max(0, val));
                  }}
                  className="w-12 bg-transparent text-center focus:outline-none text-[#00A3DA] font-bold"
                />
                <button
                  className={`bg-[#01A7E1] text-white text-2xl font-bold py-1.5 px-1.5 rounded leading-3 ${
                    limitedProductCount === 0 ? 'bg-gray-300 text-gray-500' : ''
                  }`}
                  onClick={onAdd}
                  disabled={limitedProductCount === 0}
                >
                  <img
                    src="https://cdn.builder.io/api/v1/image/assets%2F32b8c354d4bc455dbf10fed3923dfae1%2Ffbf397a88f3f44a3956db6b7db7e1ed9"
                    alt="+"
                    className="w-3 h-3"
                  />
                </button>
              </div>

              {/* Add button */}
              <button
                className={` text-white ml-3 px-2 py-1 rounded-lg min-w-[64px] ${
                  limitedProductCount === 0 ? 'bg-gray-300 text-gray-500' : 'bg-pink'
                }`}
                onClick={onAdd}
                disabled={limitedProductCount === 0}
              >
                Add
              </button>
            </div>
          </div>
        </div>
        {showDesc && (
          <div className="mt-4 rounded p-3 text-[#00A3DA] text-sm">{item.description || item.short_description || 'No details available.'}</div>
        )}
      </div>
    </div>
  );
}
